import React from 'react';
import { Button, Alert, Spinner } from '@parsina/framework';

import { C, CT, GRADIENT_BRAND_DARK } from '../../constants/theme';
import { useTranslation } from '../../i18n/I18nProvider.jsx';
import OnboardingFields from './OnboardingFields.jsx';

// The desktop frame: one card, centred on the brand gradient, above the router.
//
// It looks like the sign-in screen because it IS the same moment — the last
// step of getting in — and because there is no app chrome to put it in yet: the
// rail needs a name and a balance, and neither exists until this form is saved.

const PAGE = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100vw',
  minHeight: '100vh',
  background: GRADIENT_BRAND_DARK,
  padding: 24,
  overflowY: 'auto',
};

const CARD = {
  background: C.card,
  borderRadius: 16,
  width: 560,
  maxWidth: '100%',
  boxShadow: '0 32px 80px rgba(0,0,0,0.3)',
  padding: 32,
  margin: 'auto',
};

export default function OnboardingWeb({
  values,
  onChange,
  errors,
  submitError,
  saving,
  onSubmit,
  phone,
}) {
  const { t } = useTranslation();

  return (
    <div style={PAGE} data-testid="onboarding-web">
      <form
        style={CARD}
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <h1 style={{ color: C.navy, fontSize: 21, fontWeight: 800, margin: '0 0 6px' }}>
          {t('onboarding.title')}
        </h1>
        <p style={{ color: CT.mute, fontSize: 13.5, lineHeight: 1.9, margin: '0 0 20px' }}>
          {t('onboarding.sub')}
        </p>

        {/* The typed values are KEPT across a failure (core.md §4.3): the alert
            is rendered above the form, the form is not unmounted, and the retry
            is the same submit button. */}
        {submitError && (
          <Alert variant="error" style={{ marginBottom: 16 }} data-testid="onboarding-error">
            {submitError}
          </Alert>
        )}

        <OnboardingFields
          values={values}
          onChange={onChange}
          errors={errors}
          disabled={saving}
          phone={phone}
        />

        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 22 }}>
          <Button type="submit" disabled={saving} data-testid="onboarding-submit">
            {saving ? t('onboarding.saving') : t('onboarding.submit')}
          </Button>
          {saving && <Spinner size={16} />}
        </div>
      </form>
    </div>
  );
}
